// src/pages/PackageDetails.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../../api";
import { motion } from "framer-motion";

const PackageDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pkg = location.state?.pkg;

  const [chapters, setChapters] = useState([]);
  const [selectedChapters, setSelectedChapters] = useState([]); // ⭐ MULTIPLE
  const [loadingChapters, setLoadingChapters] = useState(false);
  const [error, setError] = useState(null);

  // Fetch chapters
  useEffect(() => {
    if (pkg?.packageType === "Chapter-wise Subscription") {
      const fetchChapters = async () => {
        setLoadingChapters(true);
        try {
          const response = await api.get(`/customer/chapter/`);
          setChapters(response.data);
        } catch (err) {
          setError(err);
        } finally {
          setLoadingChapters(false);
        }
      };
      fetchChapters();
    }
  }, [pkg?.packageType]);

  if (!pkg) {
    return <p className="text-center mt-5">No package selected.</p>;
  }

  // ⭐ Toggle chapter selection
  const toggleChapter = (chapterNumber) => {
    setSelectedChapters((prev) =>
      prev.includes(chapterNumber)
        ? prev.filter((c) => c !== chapterNumber)
        : [...prev, chapterNumber]
    );
  };

  // Extra UI
  const renderExtraDetails = (type) => {
    switch (type) {
      case "Chapter-wise Subscription":
        return (
          <>
            <h5 className="mt-4"> Choose Chapters</h5>

            {loadingChapters ? (
              <p>Loading chapters...</p>
            ) : error ? (
              <p className="text-danger">Error loading chapters.</p>
            ) : (
              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  border: "1px solid #ddd",
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                {chapters.map((chapter) => (
                  <motion.label
                    key={chapter.chapterNumber}
                    whileHover={{
                      scale: 1.02,
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                    }}
                    className="d-flex align-items-center p-2 border-bottom"
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      type="checkbox"
                      className="me-3"
                      checked={selectedChapters.includes(chapter.chapterNumber)}
                      onChange={() => toggleChapter(chapter.chapterNumber)}
                    />

                    <div>
                      <strong>{chapter.title}</strong>{" "}
                      <span className="text-muted">
                        (Chapter {chapter.chapterNumber})
                      </span>
                    </div>
                  </motion.label>
                ))}
              </div>
            )}
          </>
        );

      case "Monthly Subscription":
        return (
          <>
            <h5 className="mt-4">📅 Schedule</h5>
            <ul>
              <li>Access starts immediately after payment</li>
              <li>Renews every 30 days</li>
              <li>Choose your duration</li>
            </ul>
            <div className="mb-3">
              <label>Start Date:</label>
              <input type="date" className="form-control" />
            </div>
            <div className="mb-3">
              <label>End Date:</label>
              <input type="date" className="form-control" />
            </div>
          </>
        );

      case "Full Access":
        return (
          <>
            <h5 className="mt-4">📦 Full Access Details</h5>
            <ul>
              <li>Unlimited access to all content</li>
              <li>Valid for the entire subscription period</li>
            </ul>
            <button
              className="btn btn-info"
              onClick={() => navigate("/full-access-info")}
            >
              View More Info
            </button>
          </>
        );

      default:
        return (
          <>
            <h5 className="mt-4">ℹ Package Info</h5>
            <ul>
              <li>Standard package benefits apply</li>
              <li>Check terms & conditions before purchase</li>
            </ul>
          </>
        );
    }
  };

  // Pay Now
  const handlePayNow = () => {
    if (
      pkg.packageType === "Chapter-wise Subscription" &&
      selectedChapters.length === 0
    ) {
      alert("Please select at least one chapter before paying.");
      return;
    }

    const orderData = {
      packageId: pkg.packageId,
      packageName: pkg.packageName,
      packageType: pkg.packageType,
      selectedChapters: selectedChapters,
    };

    alert("Proceeding to payment:\n" + JSON.stringify(orderData, null, 2));
    // navigate("/payment", { state: { orderData } });
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "700px" }}>
      <h2 className="text-center mb-4">{pkg.packageName} Details</h2>

      <div className="card shadow-sm p-4">
        <p><strong>Type:</strong> {pkg.packageType}</p>
        <p><strong>Price:</strong> ₹{pkg.amount}</p>
        <p><strong>Transaction Fee:</strong> ₹{pkg.transactionFee}</p>
        <p><strong>Validity:</strong> {pkg.validity} days</p>

        {renderExtraDetails(pkg.packageType)}

        <div className="d-flex gap-2 mt-4">
          <button className="btn btn-success flex-fill" onClick={handlePayNow}>
            Pay Now
          </button>

          <button
            className="btn btn-warning flex-fill"
            onClick={() => alert("Coupon feature coming soon!")}
          >
            Use Coupon
          </button>
        </div>

        <button className="btn btn-secondary mt-2" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
    </div>
  );
};

export default PackageDetails;
